import React from 'react';
import RegisterInterest from '../../components/modals/RegisterInterest/RegisterInterest';
import SignUpModal from '../../components/modals/SignUp/SignUp';

const Pricing: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="pricing-hero">
        <div className="pricing-hero-content">
          <h1 className="pricing-hero-title">
            Free While in <span className="hero-highlight">Beta</span>
          </h1>
          <p className="pricing-hero-subtitle">
            Get full access at no cost while we're in beta. Being fully cloud-based lets us skip the overhead of
            legacy systems — so our upcoming pricing will follow a modern, flexible model at a fraction of the
            cost of traditional maritime software.
          </p>
        </div>
      </section>

      {/* Pricing Cards Section */}
      <section className="pricing-section">
        <div className="pricing-container">
          <div className="pricing-grid">
            {/* Entry Level */}
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3>Entry</h3>
                <p className="pricing-card-price">Free</p>
                <p className="pricing-card-period">during beta</p>
              </div>
              <div className="pricing-card-body">
                <ul className="pricing-features">
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Distance Table</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>ECA Areas</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>HRA Areas</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>ECA and HRA Route Optimisation</span>
                  </li>
                </ul>
              </div>
              <div className="pricing-card-footer">
                <SignUpModal showSubtext={false} />
              </div>
            </div>

            {/* Pro - Featured */}
            <div className="pricing-card pricing-card-featured">
              <div className="pricing-card-badge">Most Popular</div>
              <div className="pricing-card-header">
                <h3>Pro</h3>
                <p className="pricing-card-price">Free</p>
                <p className="pricing-card-period">during beta</p>
              </div>
              <div className="pricing-card-body">
                <ul className="pricing-features">
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Everything in Entry</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Advanced Calc</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Vessel List</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Client List</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Port Cost Memory</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Advanced Emission Calculations (ETS, FuelEU)</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Bunker Options</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Advanced Weather Factor Simulation</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>...and more</span>
                  </li>
                </ul>
              </div>
              <div className="pricing-card-footer">
                <SignUpModal showSubtext={false} />
              </div>
            </div>

            {/* Enterprise */}
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3>Enterprise</h3>
                <p className="pricing-card-price">Custom</p>
                <p className="pricing-card-period">contact us</p>
              </div>
              <div className="pricing-card-body">
                <ul className="pricing-features">
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Everything in Pro</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Single Tenant Deployment</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>SSO Integration</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Shared Vessels, Calcs & Contacts</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>Custom Integrations</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>...and more!</span>
                  </li>
                </ul>
              </div>
              <div className="pricing-card-footer">
                <RegisterInterest showSubtext={false} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Pricing;
